import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Select, Button, Modal, message } from "antd";
import PropTypes from "prop-types";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import AddEquipment from "./addEquipment";
import fetchHandler from "../../../fetch/fetchHandler";
import { getStubCfgInfo, prefixFile } from "../../../fetch/fetchApi";

const FormItem = Form.Item;

const cfgExportInfo = {};

@connect((state) => state)
class CfgExportClass extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.cfgExport;
    this.state = {
      menudata: [],
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  init() {
    fetchHandler(getStubCfgInfo, {}).then((res) => {
      if (res && res.code === "success") {
        const menuData = [];
        res.data.map((item) => {
          menuData.push(item);
          return true;
        });
        this.setState(
          {
            menudata: [...menuData],
          },
          () => {
            console.log(this.state.menudata);
          },
        );
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  handleAddBtnClick = () => {
    this.setState({
      seeAddGunVisible: true,
    });
  };

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  cancelModal = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  handleExportBtnClick = (e) => {
    e.preventDefault();
    console.log(e);
    const stubId = [];
    this.props.form.validateFieldsAndScroll((err, values) => {
      for (let i = 0; i < values.stations.length; i++) {
        stubId.push(values.stations[i].key);
      }
      cfgExportInfo["stubId"] = stubId;
      cfgExportInfo["stubCfg"] = values.cfg;
    });
    if (
      cfgExportInfo["stubId"].length <= 0
      || cfgExportInfo["stubCfg"] === undefined
    ) {
      message.error(this.internationalization.placeholder1);
    } else {
      const excelUrl = `${prefixFile}/exportStubCfgInfo.do`;
      const params = `cfgExportInfo=${JSON.stringify(cfgExportInfo)}`;

      const ele = document.createElement("a");
      ele.download = encodeURI(`${excelUrl}?${params}`);
      ele.style.display = "none";
      ele.href = encodeURI(`${excelUrl}?${params}`);
      ele.target = "_blank"; // 针对 ie模式 的浏览器
      // 触发点击
      document.body.appendChild(ele);
      ele.click();
      // 然后移除
      document.body.removeChild(ele);
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 32, offset: 1 },
      },
    };

    return (
      <Form className="login-form">
        <Form.Item
          label={`${this.internationalization.title1}:`}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 150 }}
          style={{ marginBottom: "1px" }}
        >
          <FormItem {...tailFormItemLayout} label="">
            {getFieldDecorator("stations", {
              // rules: [{
              // required: true, message: "请添加电站"
              // }],
              initialValue: (this.state && this.state.appointStations) || [],
            })(<AddEquipment />)}
          </FormItem>
        </Form.Item>

        <Form.Item
          label={`${this.internationalization.title2}:`}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem {...tailFormItemLayout} label="">
            {getFieldDecorator(
              "cfg",
              {},
            )(
              <Select
                mode="multiple"
                placeholder="请选择"
                style={{ width: "500px" }}
                showSearch
                optionFilterProp="children"
                >
                {this.state.menudata.map((item) => {
                  const option = (
                    <Select.Option value={item.propertyEn}>
                      {" "}
                      {item.propertyZh}{" "}
                    </Select.Option>
                  );
                  return option;
                })}
              </Select>,
            )}
          </FormItem>
        </Form.Item>

        <Form.Item wrapperCol={{ span: 15, offset: 5 }}>
          <Button type="primary" onClick={this.handleExportBtnClick}>
            {this.internationalization.btn1}
          </Button>
          <Button
            type="default"
            style={{ marginLeft: "20px" }}
            onClick={this.cancelModal}
          >
            {this.internationalization.btn2}
          </Button>
        </Form.Item>

        <Modal
          title={this.internationalization.btn3}
          visible={this.state.seeAddGunVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("seeAddGunVisible", false);
          }}
        >
          <AddEquipment />
        </Modal>
      </Form>
    );
  }
}

const CfgExport = Form.create()(CfgExportClass);

export default injectIntl(CfgExport);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/cfgExport.js